import { Injectable } from '@angular/core';
import { IAPIServiceProviderService } from './IAPIServiceProviderService';
import { AccountService } from '../AccountService/AccountService';
import { DocApprovalService } from '../DocApprovalService/DocApprovalService';
import { InventoryService } from '../InventoryService/InventoryService';
import { MessageService } from '../MessageService/MessageService';
import { PhysicalService } from '../PhysicalInventoryService/PhysicalService';
import { ProductService } from '../ProductService/ProductService';
import { PurchaseOrderService } from '../PurchaseOrderService/PurchaseOrderService';
import { RecipeService } from '../RecipeService/RecipeService';
import { RequisitionService } from '../RequisitionService/RequisitionService';
import { SetupService } from '../SetupService/SetupService';
import { SpoilageService } from '../SpoilageService/SpoilageService';
import { TransactionService } from '../TransactionService/TransactionService';
import { TransfersService } from '../TransfersService/TransfersService';
import { UtilityService } from '../UtilityService/UtilityService';
import { LicenceService } from '../LicenceService/LicenceService';
import { InTransitService } from '../InTransitService/InTransitService';

@Injectable({
  providedIn: 'root'
})

export class APIServiceProviderService implements IAPIServiceProviderService {
  constructor
    (
    public accountService: AccountService,
    public docApprovalService: DocApprovalService,
    public inventoryService: InventoryService,
    public messageService: MessageService,
    public physicalService: PhysicalService,
    public productService: ProductService,
    public purchaseOrderService: PurchaseOrderService,
    public recipeService: RecipeService,
    public requisitionService: RequisitionService,
    public setupService: SetupService,
    public spoilageService: SpoilageService,
    public transactionService: TransactionService,
    public transfersService: TransfersService,
    public intransitService: InTransitService,
    public utilityService: UtilityService,
    public licencingService: LicenceService
    ) {
  }
}
